import { render, staticRenderFns } from "./collectionEstate.vue?vue&type=template&id=1bbf892c&scoped=true&"
import script from "./collectionEstate.vue?vue&type=script&lang=js&"
export * from "./collectionEstate.vue?vue&type=script&lang=js&"
import style0 from "./collectionEstate.vue?vue&type=style&index=0&id=1bbf892c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbf892c",
  null
  
)

export default component.exports